class TwoImageCarousel extends HTMLElement {
  constructor() {
    super();
    this.current = 0;
  }
  connectedCallback() {
    this.track = this.querySelector('.two-image-collection__carousel-track');
    this.slides = this.querySelectorAll('.two-image-collection__carousel-slide');
    this.leftBtn = this.querySelector('.two-image-collection__carousel-arrow--left');
    this.rightBtn = this.querySelector('.two-image-collection__carousel-arrow--right');
    this.update = this.update.bind(this);
    this.leftBtn.addEventListener('click', () => {
      if (this.current > 0) {
        this.current--;
        this.update();
      }
    });
    this.rightBtn.addEventListener('click', () => {
      if (this.current < this.slides.length - 1) {
        this.current++;
        this.update();
      }
    });
    window.addEventListener('resize', this.update);
    this.update();
  }
  update() {
    const slide = this.slides[0];
    const slideWidth = slide.offsetWidth;
    this.track.style.transform = `translateX(${-this.current * (slideWidth - 20)}px)`;
    this.leftBtn.disabled = this.current === 0;
    this.rightBtn.disabled = this.current === this.slides.length - 1;
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.update);
  }
}
customElements.define('two-image-carousel', TwoImageCarousel); 